import LegalPage from "@/components/LegalPage";
export default function Privacy() {
  return <LegalPage contentKey="privacyPolicy" />;
}
